/* eslint-disable no-param-reassign */
export default function (method, delay) {
  clearTimeout(method.tId);
  method.tId = setTimeout(() => method(), delay);
}



// WEBPACK FOOTER //
// ./src/utils/debounce.js